// Module definitions — single source of truth for module keys and backend module codes.
// key: used as activity type key in stats API and activity tracking
// moduleCode: used for authorization (matches the 'code' field in org subscriptions API)

export const MODULES = {
  STATION_DESIGN: {
    key: 'station_design',
    moduleCode: 'station_improvement'
  },
  LINE_BALANCING: {
    key: 'line_balancing',
    moduleCode: 'line_balancing'
  },
  FLOOR_ANALYSIS: {
    key: 'floor_analysis',
    moduleCode: 'floor_analysis'
  },
  WORK_INSTRUCTIONS: {
    key: 'work_instructions',
    moduleCode: 'work_instructions'
  },
  ERGONOMICS: {
    key: 'ergonomics',
    moduleCode: 'ergonomics'
  },
  PMTS: {
    key: 'pmts',
    moduleCode: 'pmts'
  },
  FMEA: {
    key: 'fmea',
    moduleCode: 'fmea'
  },
  ASSEMBLY_AUTOMATION: {
    key: 'assembly_automation',
    moduleCode: 'assembly_automation'
  }
}
